import { createI13nNode, I13nButton as I13nButtonBase } from 'react-i13n';

export const I13nButton = ({
  type = 'button', // make default button type (html default is submit)
  ...restProps
}: React.ComponentProps<typeof I13nButtonBase>) => <I13nButtonBase {...restProps} type={type} />;

export const I13nClickableDiv = createI13nNode('div', {
  isLeafNode: false,
  bindClickEvent: true,
});

export { default as I13nAnchor } from './I13nAnchor';
export { default as I13nHeader } from './I13nHeader';
export { default as I13nLink } from './I13nLink';
export { default as I13nLinkOrAnchor } from './I13nLinkOrAnchor';
export { default as I13nMain } from './I13nMain';
export { default as I13nNav } from './I13nNav';
export { default as I13nNavLink } from './I13nNavLink';
export { default as I13nPreloadLink } from './I13nPreloadLink';
export { default as I13nPreloadNavLink } from './I13nPreloadNavLink';
export { default as I13nLabel } from './I13nLabel';
export { I13nDiv } from 'react-i13n';

export type { I13nModel } from './types';
